import Environment from '../../Environment';
import MockSplit from '../../MockSplit';
import Region from '../../../constants/region';
import stages from '../stages';

/**
 * Routes user/auth endpoints (GET /users/me, GET /users/lookup, etc.)
 * towards either Express or LoopBack.
 * When ON, uses Express host/builder. When OFF, falls back to LoopBack host/builder.
 *
 * This split covers the Batch 3 user/auth migration (Phase 2 routes).
 * Regions are added to ENABLED_REGIONS incrementally as each region completes
 * dev validation.
 *
 * All stages (local, dev, staging, demo, production) share the same
 * evaluationFn so that a region is enabled or disabled uniformly across
 * environments — there is no gradual per-stage rollout within this split.
 *
 * Allowlist pattern: all regions OFF by default. Add regions to ENABLED_REGIONS
 * to turn on Express user/auth endpoints for that region.
 *
 * When region is unknown (e.g. new browser tab with empty sessionStorage,
 * or cold start before region-config fetch completes), defaults to ON
 * because LoopBack is being deprecated and is turned off in some
 * environments. This is consistent with the other use_express_* splits
 * (dropoff, lab, pickup, route_session) which also default to ON.
 */

const ENABLED_REGIONS = [Region.CDI, ...Object.values(Region.TCJ), Region.UDI];

const prod = new Environment({
    name: stages.PRODUCTION,
    evaluationFn: (attributes) => {
        if (!attributes?.region) return 'on';
        if (ENABLED_REGIONS.includes(attributes.region)) return 'on';
        return 'off';
    },
});

const local = new Environment({
    ...prod,
    name: stages.LOCAL,
});

const dev = new Environment({
    ...prod,
    name: stages.DEV,
});

const staging = new Environment({
    ...prod,
    name: stages.STAGING,
});

const demo = new Environment({
    ...prod,
    name: stages.DEMO,
});

const use_express_auth_endpoints = new MockSplit({
    name: 'use_express_auth_endpoints',
    environments: [local, dev, staging, demo, prod],
});

export default use_express_auth_endpoints;
